// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".origin-price[data-v-3a255614]{font-weight:400px;color:#b7b7b7;text-decoration:line-through;font-size:18px}.discount-percent[data-v-3a255614]{font-size:14px;color:#36b079}.discount-price[data-v-3a255614]{line-height:22px;font-size:22px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
